import React from "react";
import HOC from "../../components/HOC";
import DashboardComponents from "../../components/screen/dashboard/Dashboard";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../components/constants/muiTheme";

const Dashboard = () => {
  return (
    <div className="">
      <PageTemplate
        header=""
        mainComponent={
          <ThemeProvider theme={theme}>
            <div className="text-[12px]">
              <DashboardComponents />
            </div>
          </ThemeProvider>
        }
        checkOwner={true}
      />
    </div>
  );
};

export default HOC(Dashboard);
